import { DomSanitizer } from "@angular/platform-browser";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string, normalizeSpaces: boolean = false) {
    // Rich-text editors save spaces as &nbsp;, which prevents word wrapping
    if (normalizeSpaces && value) {
      value = value.replace(/&nbsp;|&#160;|&#x0*a0;|\u00A0/gi, ' ');
    }
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}